<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import { revenueChart } from "../../views/datafake/data-usuario-detalhe";
import Stat from "@/components/widgets/stat";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Detalhes Usuário",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Stat, Loader },
  data() {
    return {
      usuarioData: {

      },
      idData: 0,
      updating: true,
      revenueChart: revenueChart,
      title: "Detalhes Usuário",
      items: [
        {
          text: "Usuários",
          href: "/usuarios/list",
        },
        {
          text: "Detalhes Usuário",
          active: true
        }
      ],
      statData: [
        {
          icon: "bx bx-check-circle",
          title: "Conversão no Mês",
          value: "1.250.000"
        },
        {
          icon: "bx bx-hourglass",
          title: "Cadastros Pendentes",
          value: "12"
        },
        {
          icon: "bx bx-package",
          title: "Não Convertido",
          value: "36.524"
        }
      ]
    };
  },
  mounted() {
    console.log('mounted usuario-detalhe_0')

    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      api.get(`${getBaseUrl()}api/usuario`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data)
        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`)
        }else{
          this.usuarioData = res.data[0]
          this.idData = this.usuarioData.id
          this.title = `Detalhes Usuário (${this.usuarioData.id}) ${this.usuarioData.name}`
          this.updating = false
        }
      })
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-4">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">{{ usuarioData.name }}</h5>
                  <p>{{ usuarioData.tipo }}</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <img
                      src="@/assets/images/users/avatar-1.jpg"
                      alt
                      class="img-thumbnail rounded-circle"
                  />
                </div>
                <h5 class="font-size-15 text-truncate">Pedidos Semana</h5>
                <p class="text-muted mb-0 text-truncate">R$ 475.800</p>
              </div>

              <div class="col-sm-8">
                <div class="pt-4">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="font-size-15">125.555</h5>
                      <p class="text-muted mb-0">Orçamentos</p>
                    </div>
                    <div class="col-6">
                      <h5 class="font-size-15">1.245</h5>
                      <p class="text-muted mb-0">Clientes</p>
                    </div>
                  </div>
                  <div class="mt-4">

                    <b-button variant="primary" :disabled="usuarioData.email === 'admin@admin.com.br'" @click="$router.push(`/usuario/editar/${idData}`)">
                      Editar Usuário
                      <i class="mdi mdi-pencil d-block font-size-16"></i>
                    </b-button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Informações Pessoais</h4>

            <p
                class="text-muted mb-4"
            >Observação usuário</p>
            <div class="table-responsive ">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">Nome Completo:</th>
                  <td>Maria da Penha</td>
                </tr>
                <tr>
                  <th scope="row">Telefone:</th>
                  <td>00.0.0000-0000</td>
                </tr>
                <tr>
                  <th scope="row">E-mail:</th>
                  <td>email@dominio.com.br</td>
                </tr>
                <tr>
                  <th scope="row">Localização:</th>
                  <td>Serra, ES</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-5">Atividade Recente</h4>
            <div class>
              <ul class="verti-timeline list-unstyled">
                <li class="event-list active">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle bx-fade-right"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-server h4 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark">Confirmação pedido 000077</a>
                        </h5>
                        <span class="text-primary">01/04/2023</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-code h4 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark">Nova interação em projeto 00088</a>
                        </h5>
                        <span class="text-primary">01/04/2023</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-edit h4 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark">Novo cadastro de cliente C88877</a>
                        </h5>
                        <span class="text-primary">01/04/2023</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>

      <div class="col-xl-8">
        <div class="row">
          <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Pedidos Semestre</h4>
            <apexchart
                class="apex-charts"
                type="bar"
                height="320"
                :series="revenueChart.series"
                :options="revenueChart.chartOptions"
            ></apexchart>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Últimos Orçamentos</h4>
            <div class="table-responsive">
              <table class="table table-nowrap table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">Data</th>
                  <th scope="col" class="text-end">Valor</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row">105</th>
                  <td>Cliente testes 00988</td>
                  <td>2 Jul, 2023</td>
                  <td class="text-end">506.888,00</td>
                </tr>

                <tr>
                  <th scope="row">104</th>
                  <td>Cliente testes 00005</td>
                  <td>1 Jul, 2023</td>
                  <td class="text-end">94.544,00</td>
                </tr>
                <tr>
                  <th scope="row">103</th>
                  <td>Cliente testes 00901</td>
                  <td>21 Jul, 2023</td>
                  <td class="text-end">15.600,00</td>
                </tr>
                <tr>
                  <th scope="row">102</th>
                  <td>Cliente testes 00775</td>
                  <td>29 Jul, 2023</td>
                  <td class="text-end">122.845,00</td>
                </tr>
                <tr>
                  <th scope="row">101</th>
                  <td>Cliente testes 00988</td>
                  <td>05 Mai, 2023</td>
                  <td class="text-end">164.548,00</td>
                </tr>
                <tr>
                  <th scope="row">100</th>
                  <td>Cliente testes 00055</td>
                  <td>17 Mai, 2023</td>
                  <td class="text-end">19.200,58</td>
                </tr>
                <tr>
                  <th scope="row">95</th>
                  <td>Cliente testes 000001</td>
                  <td>04 Nov, 2019</td>
                  <td class="text-end">9.400,00</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>
